(function (root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root && root.document) {
    api.installSearchQueryNormalizer(root.document);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  function hasAdvancedSyntax(value) {
    return /[":]|(^|\s)-\S|\b(?:AND|OR|NOT)\b/.test(value);
  }

  function normalizeSearchQuery(value) {
    const query = String(value || '').trim();

    if (!query || query.endsWith('*') || hasAdvancedSyntax(query)) {
      return query;
    }

    return query.replace(/(\S+)$/, '$1*');
  }

  function installSearchQueryNormalizer(document) {
    document.addEventListener(
      'submit',
      function (event) {
        const form = event.target;

        if (!form || !form.matches('form[role="search"]')) return;

        const action = form.getAttribute('action') || '';
        if (!/(^|\/)search(?:$|[?#])/.test(action)) return;

        const input = form.querySelector('input[name="q"]');
        if (input) input.value = normalizeSearchQuery(input.value);
      },
      true
    );
  }

  return { normalizeSearchQuery, installSearchQueryNormalizer };
});
